export default `
  body {
    width: 100%;

    &.no-scroll {
      overflow: hidden;
    }
  }
`;
